import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=5310ed14&scoped=true"
import script from "./menuItem.vue?vue&type=script&lang=js"
export * from "./menuItem.vue?vue&type=script&lang=js"
import style0 from "./menuItem.vue?vue&type=style&index=0&id=5310ed14&prod&lang=scss"
import style1 from "./menuItem.vue?vue&type=style&index=1&id=5310ed14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5310ed14",
  null
  
)

export default component.exports